module.exports = __webpack_public_path__ + "static/thumbnail-c2fd7db0cb44ff9a9d3b3667a23b88bf.jpg";